// #####################
// ### buildDateList ###
// #####################

export const buildDateList = () => {
  const myDatelist = [];
  // add number of days to date
  const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };
  // remember January is month 0
  const today = new Date();
  const today_month = today.getMonth();
  const grfsmonth = today_month !== 11 ? today_month + 1 : 0;		    // Graph starting month
  const grfsdate = new Date(2021, grfsmonth, 1);					    // standardized to 2021
  for (let x = 0; x < 365; x++) { 
    const dtdate = addDays(grfsdate, x);
    myDatelist.push(dtdate);
  };
  return myDatelist;
};


// ####################
// ### chartOptions ###
// ####################

// basic options for Highcharts plot
export const default_options = {
  title: {
    text: 'Lake Champlain Levels'
  },
  subtitle: {
    text: '.'
  },
  yAxis: {
    title: {
        text: "Water Surface Elevation (feet)"
    },
    reversed: false,
  },
  xAxis: {
    type: "datetime",
    gridLineWidth: 1,
    dateTimeLabelFormats: {
      month: '%e-%b',
      day: '%e-%b',
      hour: '%e-%b'
    },
  },
  chart: {
    zoomType: "x",
    height: window.innerHeight * 0.75,
  },
  legend: {
    symbolRadius: 0 //symbol legend square instead of default circle
  },
  credits: {
    enabled: false,
  //  href: "https://nedews.nrcc.cornell.edu",
  //  text: "Northeast DEWS"
  },
  tooltip: {
    shared: true,
    dateTimeLabelFormats: {
      month: '%B %e',
      day: '%B %e',
      hour: '%B %e'
    },
  },
  plotOptions: {
    arearange: {
      marker: {
        enabled: false
      }
    }
  },
  series: [],    //added later
};


// #########################
// ### fill_graph_crntyr ###
// #########################

// create scatter plot of current year values - accepted and provisional separately
const fill_graph = (results_data, datelist, chart) => {
  // constant part of current year series definition
  let crnt_series = {
    type: "scatter",
    lineWidth: 0,
    marker: {
        symbol: 'circle',
        lineColor: "black",
    },
    tooltip: {
        valueDecimals: 2,
        headerFormat: '<b>{series.name}</b><br/>',
        pointFormat: '{point.x:%B %e}: {point.y} feet',
    },
    zIndex: 3
  };
  // actual start/end year for graph legend
  const today = new Date();
  const actual_start_year = today.getMonth() !== 11 ? today.getFullYear() - 1 : today.getFullYear();
  const actual_end_year = today.getFullYear();
  const actual_yr_str = actual_start_year === actual_end_year ? actual_start_year : (actual_start_year + "-" + actual_end_year);

  const newSeries= [];
  const items_a = [];
  const items_p = [];
  datelist.forEach(d => {
    var ny, nm, nd, date_key;
    ny = d.getMonth() > today.getMonth() ? today.getFullYear()-1 : today.getFullYear()
    nm = (d.getMonth()+1).toString().padStart(2, '0')
    nd = (d.getDate()).toString().padStart(2, '0')
    date_key = ny + "-" + nm + "-" + nd
    if (results_data[date_key]) {
      if (results_data[date_key][1] === "A") {
        items_a.push([d.getTime(), results_data[date_key][0]])
      } else if (results_data[date_key][1] === "P") {
        items_p.push([d.getTime(), results_data[date_key][0]])
      }
    }
  })
  // fairly continuous series has smaller markers with no line around the marker
  const continuous = (items_p.length + items_a.length) > 24; 
  crnt_series.marker = {...crnt_series.marker, radius: continuous ? 3 : 4, lineWidth: continuous ? 0 : 0.5 }
  // add two scatters to graph
  if (items_a.length > 0) {
    newSeries.push({...crnt_series, name: actual_yr_str + ' (approved)', data: items_a, color: "black", legendIndex: 1});
  }
  if (items_p.length > 0) {
    newSeries.push({...crnt_series, name: actual_yr_str + ' (provisional)', data: items_p, color: "gray", legendIndex: 2})
  }
  newSeries.forEach(ns => { chart.addSeries(ns) })
};

const fetchData = (dataFileName, datelist, chart) => {
    fetch(dataFileName)
        .then(res => res.json())
        .then(results => {
            fill_graph(results, datelist, chart);
        })
        .catch(err => {
            console.error(err);
        });
};

export const fill_graph_crntyr = (dataFileName, datelist, chart) => {
    fetchData(dataFileName, datelist, chart);
}


// #######################
// ### fill_graph_pcts ###
// #######################

// add area ranges to graph
const fill_graph_areas = (pcts, datelist, sindex, chart) => {
    // area ranges and colors
    const areas = [
        ['low','2','#730000','<2nd percentile (D4)'],
        ['2','5','#E60000','2nd-5th percentile (D3)'],
        ['5','10','#FFAA00','5-10th percentile (D2)'], 
        ['10','20','#FCD37F','10-20th percentile (D1)'], 
        ['20','30','#FFFF00','20-30th percentile (D0)'], 
        ['30','high','green','>30th percentile'],
    ];

    areas.forEach(([r1,r2,color,altlabel],k) => {
        //datelist starts with first day on graph; pvals starts Jan 1
        const items = [];
        const pvals1 = pcts[r1];
        const pvals2 = pcts[r2];
        for (let x = sindex; x < 365; x++) {
            items.push([datelist[x-sindex].getTime(), pvals1[x], pvals2[x]]);
        }
        for (let x = 0; x < sindex; x++) {
            items.push([datelist[x+365-sindex].getTime(), pvals1[x], pvals2[x]]);
        }
        const newSeries = {
            name: altlabel ? altlabel : (r1 + '-' + r2 + 'th percentile'),
                data: items,
                color: color,
                fill_color: color,
                fill_opacity: 0.50,
                type: 'arearange',
                zIndex: 1,
                legendIndex: k+4
        };
        chart.addSeries(newSeries);
    });
};

// add a line to graph
const fill_graph_line = (pcts, datelist, sindex, chart, name, color, dashstyle, linewidth, legendindex) => {
    //datelist starts with first day on graph; pvals starts Jan 1
    const items = [];
    const pvals = pcts[name.toLowerCase()];
    for (let x = sindex; x < 365; x++) {
        items.push([datelist[x-sindex].getTime(), pvals[x]]);
    }
    for (let x = 0; x < sindex; x++) {
        items.push([datelist[x+365-sindex].getTime(), pvals[x]]);
    }
    const newSeries = {
        name: name !== '50' ? name : 'Median',
        data: items,
        color: color,
        lineWidth: linewidth,
        dashStyle: dashstyle,
        marker: {
        enabled: false
        },
        zIndex: 2,
        legendIndex: legendindex,
    };
    chart.addSeries(newSeries)
};

const fetchPctData = (dataFileName, datelist, sindex, chart) => {
    fetch(dataFileName)
        .then(res => res.json())
        .then(results => {
            if (results.pcts) {
                fill_graph_line(results.pcts, datelist, sindex, chart, "Low", "black", "solid", 1, 3);
                fill_graph_areas(results.pcts, datelist, sindex, chart);
                fill_graph_line(results.pcts, datelist, sindex, chart, "High", "darkgreen", "solid", 1, 9);
                fill_graph_line(results.pcts, datelist, sindex, chart, "50", "black", "Dot", 2, 10);
            }
        })
        .catch(err => {
            const newSeries = {
                name: 'Percentiles unavailable',
                data: [],
                legendIndex: 3,
                lineWidth: 0,
                marker: {
                    enabled: false
                },
            };
            chart.addSeries(newSeries);
            console.error(err);
        });

};

export const fill_graph_pcts = (dataFileName, datelist, chart) => {
    // remember January is month 0
    const oneday = 1000 * 60 * 60 * 24;  // in milliseconds
    const today = new Date();
    const today_month = today.getMonth();
    const grfsmonth = today_month !== 11 ? today_month + 1 : 0;		  // Graph starting month
    const grfsdate = new Date(2021, grfsmonth, 1)	;						    // standardized to 2021
    const sdoy = Math.ceil((grfsdate - new Date(grfsdate.getFullYear(), 0, 0, 0)) / oneday);
    const sindex = sdoy - 1;   // index of starting date in percentile arrays
    fetchPctData(dataFileName, datelist, sindex, chart);
}

